import React from "react";
import { Link } from "react-router-dom";
import { brand, footerSitemap } from "../data/siteData";
import "../styles/Footer.css";
import logo from "../assets/navimg.png";

// Self-contained sitemap-style footer — used on every page except
// Request a Quote (see FooterSimple).
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="tp-footer">
      <div className="tp-wof__bg-title-foot">❝ TERRA PALM ❞</div>
      <div className="tp-container tp-footer__brand-row">
        <span className="tp-footer__brand-mark">
          {/* <Icon name="leaf" size={26} /> */}
          <img src={logo} alt="Terra Palm" />
        </span>
        {/* <h3 className="tp-footer__brand-name">{brand.name}</h3> */}
        <p className="tp-footer__brand-desc">{footerSitemap.description}</p>
      </div>

      <div className="tp-container tp-footer__grid">
        {footerSitemap.columns.map((col) => (
          <div className="tp-footer__col" key={col.title}>
            <h5>{col.title}</h5>
            <ul>
              {col.links.map((item) => (
                <li key={item}>
                  <Link to="/handicrafts">{item}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="tp-footer__col">
          <h5>Company</h5>
          <ul>
            {footerSitemap.company.map((item) => (
              <li key={item.label}>
                <Link to={item.path}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="tp-footer__col">
          <h5>Social</h5>
          <ul>
            {footerSitemap.social.map((social) => (
              <li key={social.label}>
                <a href="/" aria-label={social.label}>
                  {social.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="tp-footer__bottom">
        <div className="tp-container tp-footer__bottom-inner">
          <span>
            &copy; {year} {brand.name}. All rights reserved.
          </span>
          <span>Crafted By: {footerSitemap.craftedBy}</span>
        </div>
      </div>
    </footer>
  );
}
